import React, { useState, useContext } from 'react';
import {defaultLoginState, formFields, LoginInterface, LoginState} from "./";
import {GlobalContext, GlobalContextI} from "global-context";
import { Input } from "components/form/input";
import { useHistory } from 'react-router-dom'
import { LOGIN } from "app/queries/Auth";
import {useMutation} from "@apollo/react-hooks";
import {ExecutionResult} from "graphql";
import {toast} from "react-toastify";
import Moment from 'moment';

export function Login() {
    const [state, setState] = useState<LoginState>(defaultLoginState)
    const { form } = state;
    const globalContext: GlobalContextI = useContext(GlobalContext)
    const history = useHistory();
    const [ login ] = useMutation(LOGIN)

    async function submitForm() {
        globalContext.setContext({loading: true})
        try {
            const response: ExecutionResult<LoginInterface> = await login({
                variables: {
                    email: form.email.value,
                    password: form.password.value
                }
            })
            //@ts-ignore
            const token = response?.data?.login.jwt
            const timeStamp = Moment().format();
            await localStorage.setItem('token', token);
            await localStorage.setItem('loginTimeStamp', timeStamp);
            globalContext.setContext({user: { ...globalContext.user, token: token}, loading: false});
        } catch(e) {
            if(e.message === 'GraphQL error: Invalid credentials') {
                toast.warn('Incorrect email and/or password')
            } else {
                toast.warn('Something went wrong')
            }
        }
    }

    if(globalContext.user.token) history.push('/admin')
    return (
        <div className='row'>
            {
                formFields.map((field, i ) =>
                    <Input label={field.label}
                           fieldName={field.fieldName}
                           col={field.col}
                           type={field.type}
                           validationRule={field.validationRule}
                           required={field.required}
                           tooltip={field.tooltip ?? undefined}
                        // @ts-ignore
                           value={state.form[field.fieldName].value}
                           updateFormData={(field, input, valid) => setState({...state, form: {...state.form, [field]: {value: input, valid}}})}
                    />
                )
            }
            <div className='form-group col-12'>
                <button className="btn d-inline" disabled={Object.values(state.form).find(x => !x?.valid) && true} onClick={() => submitForm()}>Submit</button>
            </div>
        </div>
    )
}